module.exports = __webpack_public_path__ + "img/bg3.4b97e7c1.jpg";